module.exports = __webpack_public_path__ + "img/UTHUNT.4ad0108a.png";